/* -------------------------------------------------------------------------
   VENNER — Carrusel de fotos de Revie
   Revie duplica las fotos y anima la pista con --scrollX = fotos × 100px y
   20s por vuelta, sin importar cuántas fotos haya. Este script mide el ancho
   real de una foto (con su separación) para que la vuelta cierre exacta con
   el tamaño elegido en el editor, y fija la duración según la velocidad en
   px por segundo. Lo carga la sección venner-revie-styles.
   ------------------------------------------------------------------------- */

if (!window.customElements.get('venner-revie-carousel')) {
  class VennerRevieCarousel extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById('revieDataIA');
      if (!this.root) return;

      // Revie arma el carrusel después de cargar; se espera a que aparezca.
      this.observer = new MutationObserver(() => this.setup());
      this.observer.observe(this.root, { childList: true });

      // Al cruzar el corte de móvil cambia el ancho de las fotos: se vuelve a medir.
      this.resizeObserver = new ResizeObserver(() => this.measure());

      this.setup();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }

    setup() {
      const track = this.root.querySelector('.slide-track');
      if (!track || track === this.track || track.children.length === 0) return;

      this.track = track;

      // Revie sólo anima (y duplica las fotos) cuando hay más de 4; en ese caso
      // deja --scrollX escrito en la propia pista.
      const looping = track.style.getPropertyValue('--scrollX').trim() !== '';

      if (looping) {
        const half = track.children.length / 2;
        Array.from(track.children).slice(half).forEach((slide) => slide.classList.add('vrs-dup'));
        track.classList.add('vrs-loop');
      }

      track.classList.add('vrs-ready');
      this.resizeObserver.observe(track.children[0]);
      this.measure();
    }

    measure() {
      const track = this.track;
      if (!track || !track.classList.contains('vrs-loop')) return;

      const slide = track.children[0];
      const unit = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(slide).marginInlineEnd || 0);
      if (!unit) return;

      const distance = (track.children.length / 2) * unit;
      const speed = Number(this.getAttribute('speed')) || 60;

      track.style.width = 'max-content';
      track.style.setProperty('--scrollX', `-${distance}px`);
      track.style.animationDuration = `${(distance / speed).toFixed(2)}s`;
    }
  }

  window.customElements.define('venner-revie-carousel', VennerRevieCarousel);
}
